import { addNamespace } from '@muz/jobboard-vue-client/src/store/helper/namespace';
import { merge } from 'lodash';
import LoaderTypes from './mixins/Loader';

const namespace = 'ReadabilityAndLengthAnalysis';

const Types = merge(
    {
        mutations: {
            SET_LENGTH_SCORE: 'setLengthScore',
            SET_SCORE: 'setScore',
            SET_THRESHOLD_GOOD: 'setThresholdGood',
            SET_THRESHOLD_BAD: 'setThresholdBad',
            SET_RELATED_ADS_COUNT: 'setRelatedAdsCount',
            SET_RELATED_ADS_AVG_WORD_COUNT: 'setRelatedAdsAvgWordCount',
            SET_WORD_COUNT: 'setWordCount',
            SET_AVERAGE_SCORE: 'setAverageScore',
            SET_LONGEST_WORDS: 'setLongestWords',
            SET_LONGEST_SENTENCES: 'setLongestSentences',
        },
        actions: {
            LOAD_READABILITY_AND_LENGTH_ANALYSIS:
                'loadReadabilityAndLengthAnalysis',
            LOAD_READABILITY_FREETEXT_AND_LENGTH_ANALYSIS:
                'loadReadabilityFreetextAndLengthAnalysis',
        },
    },
    LoaderTypes,
);

export const LocalTypes = {
    ...Types,
    namespace,
};

export default {
    ...addNamespace(namespace, Types),
    namespace,
};
